import React from 'react';

export const ApplContext = React.createContext();
